import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {TranslateService} from "@ngx-translate/core";
import {PrimeNG} from "primeng/config";

type BuildInfo = {
  project?: string;
  runNumber?: string;
  commit?: string;
  shortCommit?: string;
  branch?: string;
  builtAtUtc?: string;
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [
    RouterOutlet
  ]
})
export class AppComponent implements OnInit {
  title = 'Obra Cúbica';
  buildInfoLabel = 'local';
  buildInfoTitle = 'front local build';
  
  constructor(private translate: TranslateService,
              private config: PrimeNG) {
  }

  ngOnInit(): void {
    this.translate.setDefaultLang('en');
    this.translate.stream(['primeng']).subscribe((translations: any) => {
      this.config.setTranslation(translations['primeng']);
    });
    void this.loadBuildInfo();
  }

  private async loadBuildInfo(): Promise<void> {
    try {
      const response = await fetch('/build-info.json', { cache: 'no-store' });
      if (!response.ok) {
        return;
      }

      const buildInfo = await response.json() as BuildInfo;
      this.buildInfoLabel = `#${buildInfo.runNumber ?? 'local'} ${buildInfo.shortCommit ?? 'local'}`;
      this.buildInfoTitle = [
        `project: ${buildInfo.project ?? 'front'}`,
        `branch: ${buildInfo.branch ?? 'local'}`,
        `commit: ${buildInfo.commit ?? buildInfo.shortCommit ?? 'local'}`,
        `builtAtUtc: ${buildInfo.builtAtUtc ?? 'local'}`
      ].join('\n');
    } catch {
      this.buildInfoLabel = 'local';
      this.buildInfoTitle = 'front local build';
    }
  }
}
